{
  "004a86e27232fce7": "No hay visitas para verificar.",
  "0493cb969d91ea9a": "Bienvenido al Mapa de Cobertura",
  "04a42f7c16b521bc": "No hay casos abiertos de {{qualification}} a los que invitar. Crea una visita abierta para invitar a trabajadores de esta área.",
  "092bc2a87238399a": "No se presentó",
  "0bc7036b9c8f853f": "Error al verificar la visita",
  "0f7f493a341e0539": "La tarifa de pago es obligatoria",
  "14f1ef21204a85f6": "Leyendo el mapa",
  "156aa4e6e7c6ad63": "{{count}} trabajadores activos",
  "15d1c540acc06613": "Pago profesional",
  "163e44b102626149": "Evaluación",
  "18975c6a5e5e2e65": "Tipo de visita",
  "19766ed6ccb2f4a3": "Cancelar",
  "19c73a5cdf346d96": "Profesional",
  "1a1d906ff06441d4": "Invitar trabajadores con {{qualification}}",
  "1b8ca2977380b08c": "Área seleccionada",
  "1c8ac867f052ea4a": "Visita",
  "1de694364549a005": "Alta",
  "1fcbf4bdac901671": "{{count}} visita completada",
  "1fd9ae1607aa3d80": "Invitar",
  "201faecafd7fcead": "trabajador activo",
  "21a7351e10e648b7": "en vista",
  "2430b497c904988b": "Ya invitado",
  "24ad7f23a5dbf398": "Su cargo",
  "24b5201f7788af9a": "La tarifa de cargo no puede ser negativa",
  "24e1d93d66022fdc": "Evaluación de Enfermería",
  "25c547a91a6baf63": "Profesional desconocido",
  "269d7976cdbad0e3": "Requisitos faltantes",
  "276683a048d4c29a": "Número de visitas",
  "280321bbc8724bac": "Rechazar visita de {{visitType}}",
  "293e087f99c84115": "Tipo de clínico",
  "2bf936d3739dcbed": "{{count}} trabajadores activos {{qualification}}",
  "2c77e8bb09115161": "Reanudación de Atención",
  "2dc1717c0074bd4c": "Escalado de intensidad del mapa de calor (administrador)",
  "3074159c5075a11a": "Estaremos en contacto si podemos encontrar cobertura allí.",
  "307555f0e149852b": "Distancia al paciente",
  "3193ed520f35902d": "Confirmar invitación",
  "33c8e8de41c3a351": "No verificado",
  "3475b97eaa21ba68": "Verificar visita",
  "36c20ac858034224": "Verificar visita de {{visitType}}",
  "3b629d1d6fd1ce07": "Límite de intensidad máxima",
  "3b7ea51793e9d906": "Limpiar búsqueda",
  "3cb0fb41a92993af": "Visita rechazada",
  "3d6d01c471a5fafa": "Cada celda está sombreada según cuántos trabajadores de Clipboard estuvieron activos recientemente en esa área — trabajadores que reservaron o trabajaron visitas allí en los últimos 60 días, o que viven cerca y usaron Clipboard recientemente. Pasa el cursor sobre cualquier celda para ver detalles. Haz clic en cualquier parte del mapa para solicitar cobertura futura.",
  "3d756ca324ccae30": "Error al cargar las visitas. Por favor, inténtelo de nuevo.",
  "3da728ac99008608": "Llámanos para comenzar — {{phone}}",
  "41e9cda2c8d88719": "¿Enviar una invitación a {{workerName}} para esta visita?",
  "42215cf334f6e189": "No se pudieron cargar los trabajadores para esta área. Por favor, inténtalo de nuevo.",
  "425553e9d708e4f4": "No se pudieron cargar los trabajadores. Por favor, inténtalo de nuevo.",
  "44e8a4b0697f79b5": "Ver detalles de la visita",
  "45771afd6b0c2b2a": "Cada celda está sombreada según cuántos trabajadores de Clipboard han reservado o realizado visitas en esa área o viven cerca. Coloca el cursor sobre cualquier celda para ver los detalles. Haz clic en cualquier lugar del mapa para solicitar cobertura futura.",
  "461fad652d28d7cf": "La tarifa de pago no puede ser negativa",
  "467193964f475270": "Recertificación",
  "468ad2535f270ab1": "Se detectó un posible duplicado. Ya hay otra visita aprobada para este día.",
  "46931380ecf5947f": "Conecta Clipboard Health directamente a WellSky, Homecare Homebase, Axxess y más, para que la visita de registros, los perfiles de los trabajadores y la recopilación de hojas de rutas sucedan automáticamente.",
  "47fd6c9283968676": "Ver el perfil de {{name}}",
  "4807303333989588": "Admisión",
  "489ebe97d4e2f45f": "Esta visita ya ha sido verificada.",
  "4b63c8d6c82c9a2f": "Guardar tarifas",
  "4c1281cc747beda6": "Este profesional está bloqueado y no puede recibir nuevas invitaciones",
  "4dee407fa380008c": "El área resaltada muestra las visitas previamente cumplidas a través de Clipboard.",
  "4e16b652d8ad5838": "{{count}} trabajador activo {{qualification}}",
  "4f2273f736249aba": "Solicitud recibida",
  "4f7838402f37674e": "Verificado",
  "50d4275468f0c0d1": "Escala logarítmica",
  "554a75a70bcb181b": "Mostrar filtros de cobertura",
  "5ad3dbd1242a4cea": "Entendido",
  "5c9efc015b6c7e8c": "Supervisión",
  "5f8702cbcca58f90": "Este profesional ya trabaja con este caso",
  "5ff55e5f1680fcf8": "Pago profesional: {{amount}}",
  "6007acbe30b2cd98": "Aprobar",
  "6239b93e96e9a8ee": "Notas (opcional)",
  "63b17becd812dfd3": "Invitado",
  "685360feff5b8d4b": "Conecta tu EMR y automatiza el trabajo tedioso.",
  "6e7103f8c2ed7887": "¿Necesita cobertura en esta área?",
  "707fe149926f8925": "La tarifa de pago debe ser menor a $1000",
  "70b988869f2c2a82": "Solicitar cobertura futura",
  "74a0d3884d034bfb": "Notas faltantes",
  "7635fa0c85600c40": "Error al rechazar la visita",
  "764896efa69623da": "No se pudieron cargar los casos abiertos. Por favor, inténtalo de nuevo.",
  "76900f1bfd16c8d4": "Atrás",
  "76a13f805cdc1b8b": "Enviar invitación",
  "7837f28c5c87bc30": "Lo que significan las tarifas de pago",
  "78dd445a55afa050": "Pin establecido",
  "798de6b2f0278566": "No hay trabajadores que hayan completado visitas en esta área para la visita seleccionada.",
  "7a8708adfd9c68b3": "Código: {{pinLabel}}",
  "7d9eb7acb13e2462": "Cerrar",
  "7e1f964b72350f6e": "Error al enviar la invitación. Por favor, inténtelo de nuevo.",
  "835043ec8e6b7921": "Paciente",
  "85d4fc7af49f6c7e": "Los siguientes trabajadores han completado visitas en esta área",
  "8a2595eb866f0a93": "No hay visitas para mostrar.",
  "8b343cb31cf67510": "Buscar por paciente",
  "913bde576062b8e5": "Todas las visitas",
  "917e144e4bc3da89": "Enviar solicitud",
  "93309e6195d47024": "{{amount}} /hr",
  "93a7facd599f7aa5": "Selecciona una visita para ver los trabajadores disponibles.",
  "94b3dc97e7d05aaf": "Estado de la visita",
  "9bebab3f16041c90": "Ninguno (normalización automática)",
  "9c5b890662ab808e": "Motivo: {{reason}}",
  "9dbd5037c08213b8": "El área resaltada muestra los trabajadores de Clipboard que estuvieron activos recientemente en cada área.",
  "a00dd80c0367355e": "Fecha de visita",
  "a193a1ede2a1e7ae": "¿Está seguro de que desea verificar esta visita?",
  "a2b10196b0b9e407": "La tarifa de cargo debe ser menor a $1000",
  "a30a2c3a1d70672c": "{{amount}} /visita",
  "a350af311c236a5c": "Tasa de pago promedio",
  "a405ecec9397a71c": "Error al actualizar las tarifas",
  "a536f4871f6f0754": "Editar tarifas",
  "a565fb28723f9f18": "El Mapa de Cobertura aún no está habilitado para su cuenta.",
  "a630dd8f55675922": "Invitar trabajadores",
  "a67b04cd5c491d4d": "Trabajador",
  "a6b06da7806935f6": "Esta visita ya ha sido verificada y no puede ser rechazada.",
  "a78dbc1b8b4fba8a": "Detalles de la visita",
  "ab4fd936bc6d3cd0": "Haga clic en cualquier parte del mapa para solicitar cobertura en esa área.",
  "ab604a360777735f": "Rechazar",
  "aba684644f28ed36": "p. ej., Estamos recibiendo pacientes que necesitan cuidado de heridas",
  "ac56027a0ba70a7c": "Localizando…",
  "ac8991ef01019cf5": "Cargar más",
  "ac9cde5b5bee03f3": "Mapa de Cobertura",
  "aea4a04a80426ed8": "Rechazado",
  "b1041b973bc55b5e": "Verificación de visita",
  "b40a57c0c9b17557": "Invitación enviada",
  "b455784ab5307277": "Regular",
  "b944075326e4926e": "visitas",
  "b9d487da5990f1de": "Cómo funciona el Mapa de Cobertura",
  "ba3bbbe10d8bef66": "Cargando…",
  "bc4f5feffd112d99": "Visitas completadas",
  "be201bd3525b6cbb": "El mapa muestra la cobertura a nivel de organización y mercado en Clipboard — no la actividad de tu cuenta personal. Cada celda está sombreada según cuántos trabajadores estuvieron activos recientemente en esa área.",
  "be974c6d5a7b0f82": "El sombreado del mapa muestra cuántos trabajadores de Clipboard han reservado o realizado visitas en cada área o viven cerca.",
  "c019fb04d862089c": "Cargando cobertura…",
  "c19c9d3c003257b5": "Vincula cualquier EMR como WellSky, Homecare Homebase, Axxess (y muchos más) para automatizar tareas como la creación de cuentas, verificación de visitas, recolección de hojas de ruta y control de calidad.",
  "c2de3de5b2a9333c": "Valor de tope:",
  "c54580fe49a165c9": "¿Está seguro de que desea rechazar esta visita? Por favor, díganos por qué:",
  "c897635c22a67087": "Verificación de Visita",
  "cab8c775bb84486c": "Tarifa de pago",
  "cad7947500ea2aaf": "Tarifa de cargo",
  "cb6fb1213746e5f5": "Eliminar marcador",
  "cceafec6b909cdc4": "Tu solicitud indica la demanda para que podamos planificar futuras contrataciones en esta área. No ha creado un caso ni activado un flujo de trabajo de cumplimiento urgente.",
  "d075ae70f9a81c5c": "Verifique solo después de confirmar que la documentación cumple con sus estándares.",
  "d1b90358bb105a2c": "Aún no hay trabajadores activos recientemente en esta área. Haz clic en cualquier parte del mapa para solicitar cobertura aquí.",
  "d46949d0ff447b1c": "El mapa muestra la cobertura a nivel de organización y de mercado en Clipboard, no la actividad de tu cuenta personal. Cada celda está sombreada según cuántos trabajadores han reservado o realizado visitas en esa área o viven cerca.",
  "d8402b10271eab51": "Editar tarifas de {{visitType}}",
  "d8ef3d7510e714d1": "La tarifa de cargo es obligatoria",
  "dad8b127d02555df": "Tu cargo: {{amount}}",
  "daea89e163898dd1": "Las notas no pasaron la QA",
  "dc3838919b70dd24": "Solicitud duplicada",
  "e57499264f493e58": "Razón de rechazo",
  "e92eea890c7f4b8b": "Límite de intensidad del mapa de calor",
  "e954de46c25f5126": "Admisión y Primer",
  "ea68cfee139df482": "trabajadores activos",
  "eab0cd8fdf9bccec": "Por Hora",
  "eb36aff7bf025843": "¿De quién son estos datos?",
  "ed8887d8ed8106fd": "{{count}} visitas completadas",
  "eea2745e2867a677": "Verificar",
  "f0e68ac26df21840": "visita",
  "f124a41b43f90504": "Faltan documentos requeridos",
  "f21be567be440aea": "Selecciona un paciente para continuar.",
  "f2a7559ff9872a2b": "Rechazar visita",
  "f3531a486fe06c2c": "Visita aprobada",
  "f509fc0b514d654c": "Buscar una ciudad o dirección",
  "f56bc1e7bc084f94": "Error al cargar el mapa de cobertura. Por favor, inténtelo de nuevo.",
  "f81ab834de5f8491": "Razón",
  "f97e9da0e3b879f0": "Otro",
  "fbdd2c9ace74f84d": "Aún no hay visitas completadas en esta área. Haga clic en cualquier parte del mapa para solicitar cobertura aquí.",
  "fd1346d7693d29af": "{{count}} trabajador activo"
}
